import { EndorsementsCountBadge } from '@pages/User/components';
import type { ColumnHelper } from '@tanstack/react-table';
import { get } from 'lodash-es';

enum ShowCommentsOptions {
  Show = 'SHOW',
  Hide = 'HIDE',
}

const commentsFilterOptions = [
  { value: ShowCommentsOptions.Show, label: 'With comments' },
  { value: ShowCommentsOptions.Hide, label: 'Without comments' },
];

export const commentsAccessor = <T extends { unresolvedCommentsCount?: number }>(columnHelper: ColumnHelper<T>) =>
  columnHelper.accessor((entity) => entity.unresolvedCommentsCount, {
    id: 'commentsCount',
    header: 'Comments',
    cell: (cellContext) => <EndorsementsCountBadge count={cellContext.getValue() ?? 0} label="Comment" />,
    sortUndefined: 'last',
    meta: {
      filter: {
        label: 'Comments',
        placeholder: 'Show comments',
        isSingleSelection: true,
        optionsMapping: commentsFilterOptions,
        order: Number.MAX_SAFE_INTEGER,
      },
      headingCellClassName: '2xl:w-24',
    },
    filterFn: (row, _, selected) => {
      const commentsCount = get(row.original, 'unresolvedCommentsCount', 0);
      if (selected === ShowCommentsOptions.Show) {
        return commentsCount >= 1;
      }

      if (selected === ShowCommentsOptions.Hide) {
        return commentsCount < 1;
      }

      return true;
    },
  });
